import React, { FC } from "react";
import AppViewCubit from "src/state/AppViewCubit/AppViewCubit";
import styled from "@emotion/styled";
import Logo from "src/ui/assets/icons/Logo";
import { useBlocNext } from "@blac/react";

const Position = styled.div`
  font-size: 0.82rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
  display: flex;
  align-items: baseline;
  margin-bottom: 1.8rem;
  pointer-events: none;

  svg {
    width: auto;
    height: 1em;
    margin-left: 0.3em;
    display: inline-block;
    position: relative;
    top: 0.084em;
  }
`;

const PoweredByWidget: FC = () => {
  const [{ partnerSession }] = useBlocNext(AppViewCubit);
  if (!partnerSession) {
    return null;
  }
  return (
    <Position>
      <span>by</span> <Logo />
    </Position>
  );
};

export default PoweredByWidget;
